'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _KendoDataSourceBase = require('../KendoDataSourceBase');

var _KendoDataSourceBase2 = _interopRequireDefault(_KendoDataSourceBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    mixins: [_KendoDataSourceBase2.default],
    mounted: function mounted() {
        this.kendoDataSource = new kendo.data.DataSource(this.widgetOptions);
    },

    methods: {
        kendoWidget: function kendoWidget() {
            return this.kendoDataSource || new kendo.data.DataSource(this.widgetOptions);
        }
    }
};